




















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EmailSent extends Vue {}
